module.exports = __webpack_public_path__ + "arrow_left.270f72df47e036d9cfa1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/svg/arrow_left.svg
// module id = 210
// module chunks = 2